import { Injectable } from '@angular/core';
import { LiabilityMenuDisabledState, LiabilityStatus } from '../models/model';
import { ArchiveStatus } from '../../billers/models/archive-status';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LiabilityItemService {
  public liabilityItemMenuDisabled$: BehaviorSubject<LiabilityMenuDisabledState> = new BehaviorSubject<
    LiabilityMenuDisabledState
  >(LiabilityMenuDisabledState.ENABLED);

  private addToCartStatuses: Array<LiabilityStatus> = [
    LiabilityStatus.NOT_PAID,
    LiabilityStatus.OVERDUE,
    LiabilityStatus.SCHEDULED_NOT_PAID,
    LiabilityStatus.UNKNOWN,
  ];

  constructor() {}

  public canShowCheckboxForItem(
    liabilityStatus: LiabilityStatus,
    liabilityPayable: boolean,
    liabilityAmount: number,
    archiveStatus: ArchiveStatus,
  ): boolean {
    return (
      this.addToCartStatuses.includes(liabilityStatus) &&
      (liabilityPayable || (!liabilityPayable && !liabilityAmount)) &&
      archiveStatus === ArchiveStatus.UNARCHIVED
    );
  }

  public changeLiabilityItemMenuDisabled(value: LiabilityMenuDisabledState) {
    this.liabilityItemMenuDisabled$.next(value);
  }
}
